import type { ReminderTypeResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { REMINDER_TEMPLATE_LABELS } from "web_myplann/Reminders/Config/reminderTemplateLabels";
import type { ReminderTemplate } from "web_myplann/Reminders/Types/ReminderTypes";

export const mapReminderTypeDto = (
	dto: ReminderTypeResponseDTO,
): ReminderTemplate => ({
	typeKey: dto.typeKey,
	labelKey: dto.isCustom
		? Resources.Reminders.Form.customTemplate
		: (REMINDER_TEMPLATE_LABELS[dto.typeKey] ?? null),
	recurrence: dto.defaultRecurrence,
	isCustom: dto.isCustom,
});
